module.exports = __webpack_public_path__ + "img/3.c3dc482c.jpg";